import React from 'react';
import { usePWAInstallStore } from '../../stores/pwaInstallStore';
import './InstallBanner.css';

const InstallBanner: React.FC = () => {
  const { showBanner, triggerInstall, dismissBanner } = usePWAInstallStore();

  if (!showBanner) return null;

  const handleInstall = async () => {
    await triggerInstall();
  };

  return (
    <div className="install-banner">
      <span className="install-banner__text">
        Add to Home Screen for quick access
      </span>
      <div className="install-banner__actions">
        <button
          className="install-banner__btn install-banner__btn--install"
          onClick={handleInstall}
        >
          Install
        </button>
        <button
          className="install-banner__btn install-banner__btn--close"
          onClick={dismissBanner}
          aria-label="Close"
        >
          &times;
        </button>
      </div>
    </div>
  );
};

export default InstallBanner;
